import { css } from '@/styled-system/css';

export const triggerButtonStyles = css.raw({
  display: 'inline-flex',
  borderRadius: 'shape.ellipse',
  position: 'relative',
  verticalAlign: 'top',
  cursor: 'pointer',

  _after: {
    content: '""',
    cursor: 'inherit',
    position: 'absolute',
    inset: '-5px',
  },

  _focusVisible: {
    boxShadow: 'focus',
  },
});

export const triggerButtonDefaultIconStyles = css.raw({
  '& > [data-c11n-component="Icon"] > .c11n-help-circle': {
    fill: 'bg.action.neutral.default',
    stroke: 'border.action.neutral.default',
  },

  '& > [data-c11n-component="Icon"] > .c11n-help-question-mark': {
    fill: 'text.action.neutral.default',
  },

  '_hover': {
    '& > [data-c11n-component="Icon"] > .c11n-help-circle': {
      fill: 'bg.action.neutral.hover',
    },
  },

  '_active': {
    '& > [data-c11n-component="Icon"] > .c11n-help-circle': {
      fill: 'bg.action.neutral.pressed',
      stroke: 'border.action.neutral.pressed',
    },
  },
});
